<template>
    <div class="row">
        <div class="col-lg-12">
            <OrderMainInformation :order="order" @update="order = $event" />
        </div>
        <div class="col-lg-2">
            <OrderClientCard :order="order" v-if="order"/>
        </div>
        <div class="col-lg-10">
            <NavTab class="nav-tabs-bottom">
                <NavTabItem key="#product" :active="isActiveTab(['OrderProducts'])" @click="changePage('OrderProducts')" href="#">
                    <i class="icon-cart mr-2"></i>
                    {{ $t('sidebar.items.products') }}{{ order?.sum ? ` (${order.sum} грн.)` : '' }}
                </NavTabItem>
                <NavTabItem key="#exitDeclarations" :active="isActiveTab(['OrderExitDeclarations'])" @click="changePage('OrderExitDeclarations')" href="#">
                    <i class="icon-box-remove mr-2"></i>
                    {{ $t('sidebar.items.exitDeclarations') }}
                </NavTabItem>
                <NavTabItem key="#deliveries" :active="isActiveTab(['OrderDeliveriesPage', 'OrderDeliveriesCreatePage', 'OrderDeliveriesEditPage'])" @click="changePage('OrderDeliveriesPage')" href="#">
                    <i class="icon-truck mr-2"></i>
                    {{ $t('sidebar.items.deliveries') }}
                </NavTabItem>
                <NavTabItem key="#payments" :active="isActiveTab(['OrderPaymentsPage', 'OrderPaymentCreatePage', 'OrderPaymentEditPage'])" @click="changePage('OrderPaymentsPage')" href="#">
                    <i class="icon-cash mr-2"></i>
                    {{ $t('sidebar.items.payments') }}
                </NavTabItem>
                <NavTabItem key="#expenses" :active="isActiveTab(['OrderExpensesIndexPage', 'OrderExpenseCreatePage', 'OrderExpenseEditPage'])" @click="changePage('OrderExpensesIndexPage')" href="#">
                    <i class="icon-coin-dollar mr-2"></i>
                    {{ $t('sidebar.items.expenses') }}{{ order?.expenses_sum ? ` (${order.expenses_sum} грн.)` : '' }}
                </NavTabItem>
                <NavTabItem key="#customFields" :active="isActiveTab(['OrderCustomFieldsPage'])" @click="changePage('OrderCustomFieldsPage')" href="#">
                    <i class="icon-cogs mr-2"></i>
                    {{ $t('sidebar.items.customFields') }}
                </NavTabItem>
                <NavTabItem key="#integrationOrder" :active="isActiveTab(['IntegrationOrder'])" @click="changePage('IntegrationOrder')" href="#">
                    <i class="icon-link mr-2"></i>
                    {{ $t('sidebar.items.integrationOrder') }}
                </NavTabItem>
                <NavTabItem key="#history" :active="isActiveTab(['OrderHistory'])" @click="changePage('OrderHistory')" href="#">
                    <i class="icon-history mr-2"></i>
                    {{ $t('sidebar.items.history') }}
                </NavTabItem>
                <NavTabItem key="#sms" :active="isActiveTab(['OrderSmsPage'])" @click="changePage('OrderSmsPage')" href="#">
                    <i class="icon-bubble mr-2"></i>
                    {{ $t('sidebar.items.sms') }}
                </NavTabItem>
            </NavTab>
            <router-view v-slot="{ Component }">
                <component
                    v-if="order"
                    :is="Component"
                    :order="order"
                    @update="fetchOrder()"
                >
                </component>
            </router-view>
        </div>
    </div>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import OrderMainInformation from "./sidebarCards/OrderMainInformationCard.vue";
import OrderClientCard from "./sidebarCards/OrderClientCard.vue";
import NavTab from "../../../components/tabs/NavTab.vue";
import NavTabItem from "../../../components/tabs/NavTabItem.vue";

import { httpClient } from "../../../../services/HttpClient";
import MessageNotificator from "../../../../services/MessageNotificator";

export default {
    name: "OrdersEditPage",
    components: {
        Card, OrderMainInformation, OrderClientCard, NavTab, NavTabItem
    },
    data() {
        return {
            order: null
        }
    },
    methods: {
        fetchOrder() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}`).then((response) => {
                this.order = response.data.data
            })
        },
        changePage(pageName) {
            this.$router.push({name: pageName})
        },
        isActiveTab(routeNames) {
            const isActive = routeNames.includes(this.$route.name)

            return isActive
        }
    },
    mounted() {
        this.fetchOrder()
    }
}
</script>